<div class="container-full" style="margin-top:15px;">
    <div class="ace-heading-banner">
        <div style="padding-top:18px;">
            <span class="ace-heading-text-level-1" style="margin-left:25px;color:white;">Amano One PARCS Sync</span>
         </div>
    </div>
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>
@if(loadingMessage){
    <app-processing-banner [WaitMessage]="loadingMessage"></app-processing-banner>
}

@if(undefined == isParcsEnabledForCurrentLotNumber) {
    <div style="margin-top:20px;">
        <p style="font-size:18px;font-weight: bold;color:black;">Getting PARCS status for Lot Number {{_appGeneralStateService.currentLotNumber}}</p>
    </div>
}

@if(false == isParcsEnabledForCurrentLotNumber) {
    <div style="margin-top:20px;">
        <p style="font-size:18px;font-weight: bold;color:red;">PARCS is not activated for Lot Number {{_appGeneralStateService.currentLotNumber}}. Please activate PARCS to enable Amano One PARCS Sync functionality.</p>
    </div>
}

@if(isParcsEnabledForCurrentLotNumber) {
<button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:0px;width:300px;" (click)="getSyncDataForLot(_appGeneralStateService.currentLotNumber)">Get Parker/PARCS Sync Data</button>
<hr />

@if(!loadingMessage) {
    @if(syncData && syncData.length == 0){
        <p>No sync data available.</p>
    }
    @else if(syncData && syncData.length > 0)
    {
        
        @if(this.syncData.length > 0){
        <div class="row" style="margin-top:10px;margin-bottom:20px;">
            <div class="col-4">
                <div style="font-size:18px;font-weight: bold;">Select View</div>
                    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" [(value)]="selectedSyncStatusToggle" (change)="onViewChange($event.value)" hideSingleSelectionIndicator="true">
                        <mat-button-toggle value="all">
                            <mat-icon style="color: black; margin-right: 8px;">list</mat-icon>
                            All @if(selectedSyncStatusToggle === 'all'){({{this.displaySyncData.length}})}
                        </mat-button-toggle>
                        <mat-button-toggle value="match">
                            <mat-icon style="color: #4CAF50; margin-right: 8px;">arrow_circle_right</mat-icon>
                            Synced @if(selectedSyncStatusToggle === 'match'){({{this.displaySyncData.length}})}
                        </mat-button-toggle>
                        <mat-button-toggle value="ready">
                            <mat-icon style="color: #4CAF50; margin-right: 8px;">sync</mat-icon>
                            Ready @if(selectedSyncStatusToggle === 'ready'){({{this.displaySyncData.length}})}
                        </mat-button-toggle>
                        <mat-button-toggle value="review">
                            <mat-icon style="margin-right: 8px;">edit</mat-icon>
                            Review @if(selectedSyncStatusToggle === 'review'){({{this.displaySyncData.length}})}
                        </mat-button-toggle>
                        <mat-button-toggle value="unable">
                            <mat-icon style="color: #f44336; margin-right: 8px;">block</mat-icon>
                            Unable @if(selectedSyncStatusToggle === 'unable'){({{this.displaySyncData.length}})}
                        </mat-button-toggle>
                         <mat-button-toggle value="synced">
                            <mat-icon style="color: #4CAF50; margin-right: 8px;">done_all</mat-icon>
                            Sync Applied @if(selectedSyncStatusToggle === 'synced'){({{this.displaySyncData.length}})}
                        </mat-button-toggle>
                </mat-button-toggle-group> 
                <br />
                <br />
                <span>{{syncStatusDescription}}</span>   
                    <br />
                  @if(selectedSyncStatusToggle == 'ready'){
                    <button type="button" class="btn btn-primary mt-3 ace-blue" 
                        style="margin-left:0px;width:300px;"
                        (click)="onSyncNowParkerToParcs()">Sync All Matched Parkers</button>
                    }

                    @if(selectedSyncStatusToggle == 'match'){
                    <button type="button" class="btn btn-primary mt-3 ace-blue" 
                        style="margin-left:0px;width:300px;"
                        (click)="onSyncNowSyncMatchedParkers()">Update All Synced Parkers</button>
                    }
            </div>
             <div class="col-2">
              
            </div>
            <div class="col-6">
                <br />
                <span><strong>Discrepancy Analysis</strong></span><br />
                <span>spACE AR Parkers: {{this.numberOfParkersFound}}</span><br />
                <span>PARCS Parkers: {{this.numberOfParcsFound}}</span><br />
                <span>Parker Name: {{this.parkerNameMatches}}</span><br />
                <span>Company Name: {{this.companyNameMatches}}</span><br />
                <span>No key card number: {{matchedRecordsCount}}</span><br />
            </div>
            
            <br /><br />
            <!-- <div class="col-3">
               
            </div> -->
            <div class="col-12">
                <mat-icon style="color:green;font-size: 36px; width: 36px; height: 36px;position:relative;top:15px;">announcement</mat-icon> &nbsp;&nbsp;<span><strong>Data reflected in spACE AR will update the PARCS information for each keycard</strong></span>
            </div>
        </div>
        }
        <div>

        </div>
       <ng-container *ngIf="displaySyncData && displaySyncData.length > 0">
       <igx-grid #gridParkerSync id="gridParkerSync" [data]="this.displaySyncData" [width]="'99%'" [height]="'2000px;'" [autoGenerate]="false" style=margin-left:10px;margin-top:10px;
            paste-handler  [primaryKey]="'parkerAccountNumberId'" [rowEditable]="false" [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact" 
            [emptyGridMessage]="'Parker Amano One Sync Data'"  [clipboardOptions]="options" paste-handler>

         <igx-column field="" width="50px" required>
            <ng-template igxHeader>
                
            </ng-template>
            <ng-template igxCell let-cell="cell" let-value>
                @if (cell.row.data.status == 0) {
                     <div style="position:relative; top: -5px;">
                      <button mat-icon-button aria-label="Sync Parker to PARCS"  matTooltip="Ready for Sync" (click)="onEditThenSyncParkerToParcs(cell.row.data)"
                              style="width: 36px; height: 36px; line-height: 36px; color: #093d0a;">
                        <mat-icon style="font-size: 24px; width: 25px; height: 25px;">sync</mat-icon>
                    </button>
                     </div>
                }
               
                @if (cell.row.data.status == 1) {
                     <div style="position:relative; top: -5px;">
                      <button mat-icon-button aria-label="Sync Parker to PARCS" matTooltip="Edit Parker/PARCS" (click)="onEditThenSyncParkerToParcs(cell.row.data)"
                              style="width: 36px; height: 36px; line-height: 36px; color: black;">
                        <mat-icon style="font-size: 24px; width: 25px; height: 25px;">edit</mat-icon>
                    </button>
                     </div>
                }
                @if (cell.row.data.status == 2) {
                     <div style="position:relative; top: -5px;">
                      <button mat-icon-button aria-label="Sync Parker to PARCS"  matTooltip="Unable to Sync" 
                              style="width: 36px; height: 36px; line-height: 36px; color: red;">
                        <mat-icon style="font-size: 24px; width: 25px; height: 25px;">block</mat-icon>
                    </button>
                     </div>
                }

                 @if (cell.row.data.status == 10) {
                     <div style="position:relative; top: -5px;">
                      <button mat-icon-button aria-label="Sync Parker to PARCS"  matTooltip="Unable to Sync" 
                              style="width: 36px; height: 36px; line-height: 36px; color: green;">
                        <mat-icon style="font-size: 24px; width: 25px; height: 25px;">check</mat-icon>
                    </button>
                     </div>
                }
                              
            </ng-template>
        </igx-column>



        <igx-column field="parkerCardNumber" [sortable]="true" width="200px" required [sortable]="true">
            <ng-template igxHeader>
                <span style="font-size:large;font-weight: bold;;">spACE AR Parkers</span><br />Card No
            </ng-template>
            <ng-template igxCell let-cell="cell" let-value>
                <div [ngStyle]="{
                    'background-color': cell.row.data.cardNumbersDifferent ? '#ffebee' : (!value || value === '' || value == null) ? '#yellow' : 'transparent',
                    'color': cell.row.data.cardNumbersDifferent ? 'black' : 'black',
                    'width': '100%',
                    'height': '100%',
                    'display': 'flex',
                    'align-items': 'center',
                    'padding': '8px',
                    'box-sizing': 'border-box'
                }">
                    {{ value || '' }}
                </div>
            </ng-template>
        </igx-column>

          <igx-column field="parkerFullName" header="Parker" width="200px" required [sortable]="true" >
            <ng-template igxCell let-cell="cell" let-value>
                <div [ngStyle]="{
                    'background-color': cell.row.data.parkerNameDifferent ? '#ffebee' : (!value || value === '' || value == null) ? '#yellow' : 'transparent',
                    'color': cell.row.data.parkerNameDifferent ? 'black' : 'black',
                    'width': '100%',
                    'height': '100%',
                    'display': 'flex',
                    'align-items': 'center',
                    'padding': '8px',
                    'box-sizing': 'border-box'
                }">
                    <a matButton href="javascript:void(0)"
                    class="mimic-button-hover"
                     (click)="onCopyMessage('Parker Id copied to clipboard')"
                     [cdkCopyToClipboard]="cell.row.data.spAceArParkerId" 
                    >{{value}}</a>
                </div>
            </ng-template>
             <ng-template igxCell let-cell="cell" let-value>
                    <a matButton href="javascript:void(0)"
                    class="mimic-button-hover"
                     (click)="onCopyMessage('Parker Id copied to clipboard')"
                     [cdkCopyToClipboard]="cell.row.data.spAceArParkerId" 
                    >{{value}}</a>
            </ng-template>
        </igx-column>

        <igx-column field="parkerCompanyName" header="Company" width="200px" required [sortable]="true" >
            <ng-template igxCell let-cell="cell" let-value>
                <div [ngStyle]="{
                    'background-color': cell.row.data.companyNameDifferent ? '#ffebee' : (!value || value === '' || value == null) ? '#yellow' : 'transparent',
                    'color': cell.row.data.companyNameDifferent ? 'black' : 'black',
                    'width': '100%',
                    'height': '100%',
                    'display': 'flex',
                    'align-items': 'center',
                    'padding': '8px',
                    'box-sizing': 'border-box'
                }">
                    {{ value || '' }}
                </div>
            </ng-template>
        </igx-column>

        <igx-column field="parkerStartDate" header="Start Date" width="125" required [sortable]="true" >
             <ng-template igxCell let-cell="cell" let-value>
                @if(value && value !== '' && value !== '0001-01-01T00:00:00') {
                    {{ value | date:'shortDate' }}
                }
                @else {
                    --
                }
            </ng-template>
        </igx-column>

        <igx-column field="parkerEndDate" header="End Date" width="125" required [sortable]="true" >
            <ng-template igxCell let-cell="cell" let-value>
                @if(value && value !== '' && value !== '0001-01-01T00:00:00') {
                    {{ value | date:'shortDate' }}
                }
                @else {
                    --
                }
            </ng-template>
        </igx-column>

        <igx-column field="" header="" width="20px" required [sortable]="false">
            <ng-template igxCell let-cell="cell" let-value>
                    {{ value || '' }}
            </ng-template>
        </igx-column>

        <igx-column field="amanoOneCardNumber" [sortable]="true" width="200px" required [sortable]="true">
            <ng-template igxHeader>
                <span style="font-size:large;font-weight: bold;;">PARCS Parkers</span><br />Card No
            </ng-template>
        </igx-column>

        <igx-column field="amanoOneFullName" header="Parker" width="200px" required [sortable]="true">
            <ng-template igxCell let-cell="cell" let-value>
                    {{ value || '' }}
            </ng-template>
        </igx-column>

        <igx-column field="amanoOneCompanyName" header="Company" width="200px" required [sortable]="true" ></igx-column>

        <igx-column field="amanoOneAccessHolderId" [sortable]="true" width="250px" required [sortable]="true">
            <ng-template igxHeader>
                <span style="font-size:large;font-weight: bold;;">Access Holder ID</span>
            </ng-template>
        </igx-column>

        <igx-column field="" header="" width="20px" required [sortable]="false">
            <ng-template igxCell let-cell="cell" let-value>
                    {{ value || '' }}
            </ng-template>
        </igx-column>

        

<igx-grid-toolbar>
    <igx-grid-toolbar-actions>
        <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
        <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
        <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
    </igx-grid-toolbar-actions>
</igx-grid-toolbar>

</igx-grid>


</ng-container>

        <!-- If no data to display -->
        <ng-container *ngIf="displaySyncData && displaySyncData.length == 0">
            <strong>No Parker sync data available for the selected view.</strong>
        </ng-container>
    }
}
}
</mat-card-content>
</mat-card>